/* eslint-disable camelcase */
import {useMemo} from 'react';

const usePracticeAreaDefaultValues = (practiceArea = {}) => {
  const {id, name, description, areas_of_expertise, search} = practiceArea || {};

  return useMemo(() => {
    if (!practiceArea || !Object.keys(practiceArea).length) {
      return {};
    }

    return {
      id,
      name,
      description,
      search,
      areas_of_expertise,
    };
  }, [practiceArea, id, name, description, search, areas_of_expertise]);
};

export default usePracticeAreaDefaultValues;
